import axios from 'axios';
export default class Addons{
    constructor(profile){
        this.profilePage=profile;
        this.addonsListHTML=$("#addons-manager-list");
        this.updateAddonsButton=$("#update-addons-modal");
        this.managerModal=$("#addon-manager-modal");
        this.addons=[];
        this.plan;
        this.myAddons=[];
        this.quantity=1;
        this.hasLicenses=false;
        this.interval="month";
        this.addonSummaryItems=$("#addon-manager-summary");
        this.addonSummaryTotal=$("#addon-manager-total");
        this.agreeTermsCheckbox=$("#addon_privacy_policy");
        this.errorMessage=$("#addon_response_error");
        this.initialSelectedIds=[];
        this.onClose=()=>{};
    };

    load(){
        $("#addon_privacy_policy_error").html('');
        this.agreeTermsCheckbox.prop({checked:false});
        this.agreeTermsCheckbox.off('change');
        this.agreeTermsCheckbox.on('change',()=>{
            if(this.agreeTermsCheckbox.is(':checked')){
                $("#addon_privacy_policy_error").html('');
            }
        })

        //summary clean
        this.addonSummaryTotal.html(`$0.00/${this.interval}`)
        this.addonSummaryItems.html(`<tr>
                <td class="vertical-align-top" colspan=4 >
                    <div class="d-flex justify-content-center mb-1 w-100">
                        <span class="invoice-item-name text-invoice-amount">No selected add-ons</span>
                    </div>
                </td>
        </tr>`);

        this.setError('');
        this.disableSubmitButton();
        this.setAddonsLoading();
        this.updateAddonsButton.off();
        this.updateAddonsButton.on('click',()=>{
            this.updateAddons();
        });
        this.managerModal.modal('show')
        setTimeout(() => {
            this.getAddons();
        }, 1000);
    };


    getAddons(){
        axios.get('/profile/billing/addons').then(response=>{
            if(response.data.available){
                this.available=response.data.available;
            }
            if(response.data.plan && response.data.plan.length){
                this.plan=response.data.plan[0];
                this.interval=this.plan.interval;
                this.quantity=this.plan.licenses > 1 ? this.plan.licenses : 1;
                this.hasLicenses=this.plan.has_licenses;
            }
            if(response.data.addons){
                this.myAddons=response.data.addons;
            }
            this.renderAvailableAddons();
        }).catch(err=>{
            console.error(err);
        })
    };

    renderAvailableAddons(){
        // if(this.plan){
            if(!this.hasLicenses){
                $('#addon-manager-licenses-toggle').removeClass('has-licenses');
            }else{
                $('#addon-manager-licenses-toggle').addClass('has-licenses');
            }
            if(this.available && this.available.length){
                this.addonsListHTML.html('')
                this.available.forEach(addon=>{
                    // if(addon.owned){
                    //     this.initialSelectedIds.push(addon.id);
                    // }
                    this.renderAddon(addon);
                })
                this.onSelectionChanged();
            }else{
                //no available addons
            }
        // }else{
        //     // you should have a active plan
        // }
    }

    setAddonsLoading(){
        this.addonsListHTML.html(`
        <tr>
            <td class="vertical-align-top border-0 px-0 py-1" colspan=3>
                <div class="d-flex w-100 justify-content-center align-items-center loading-addons flex-column">
                    <div class="spinner-grow text-secondary mb-3" style="width: 3rem; height: 3rem;" role="status">
                    </div>
                    <span>Loading available add-ons...</span>
                </div>
            </td>
            </tr>
        `);
    }
    renderAddon(addon){
        const manager=this;
        const owned=this.myAddons.find(a=>a.id==addon.id);
        const periodEnd=moment(this.profilePage.subscription.period_end);
        const available=addon.type!='workspace' || this.hasLicenses;
        const addonName=$("<td/>",{
            nowrap:'',
            class:'vertical-align-top border-0 px-0 py-2 sm-vertical-align-middle',
            html:`<div class="d-flex align-items-center mb-1">
                <div class="d-flex justify-content-center align-items-center hide-on-licenses ml-3">
                    <div class="kino-checkbox square mr-2">
                        <input  type="checkbox" value="${addon.id}" name="manager_addon_selected_checkbox" value="${addon.id}" id="manager_addon_checkbox_${addon.id}" ${owned ? 'checked' : ''}>
                        <label for="manager_addon_checkbox_${addon.id}"></label>
                    </div>
                </div>
                <div class="d-flex flex-column text-lg flex-1">
                    <span class="invoice-item-name text-invoice-amount text-lg sm-text-small">${addon.name}</span>
                    <small class="invoice-item-desc text-invoice-desc sm-hidden">${addon.description}</small>
                    ${ addon.canceled > 0 ? `<small class="invoice-item-desc text-info sm-text-small" style="white-space: break-spaces;"><i class="fa fa-info-circle" aria-hidden="true"></i> Additional ${addon.canceled} ${addon.name} are available for use until <u>${periodEnd.format('MMM Do')}</u>${periodEnd.format(', YYYY')}` : ''}
            </div>
           </div>`
        });

        const addonPrice=$("<td/>",{
            class:"vertical-align-top border-0 px-0 py-2 sm-vertical-align-middle",
            html:`<div class="d-flex justify-content-end align-items-start mb-1 price-cell">
                <span class="invoice-line-amount text-invoice-amount text-lg sm-text-small">$${this.interval == "month" ? addon.month_price /100 : addon.year_price/100}/${this.interval == "month" ? "mo" : "y"}</span>
            </div>`
        });

        const addonQtyInput=$("<input/>",{
            class:"addon-qty-input",
            name:"purchase_addon_qty_input",
            type:"number",
            min:owned ? owned.in_use : 0,
            step:1,
            'addon-id':addon.id,
            max:!available ? 0 : this.quantity,
            value:!available ? 0 : owned ? owned.qty : 0
        }).on('change',this.onSelectionChanged.bind(manager));
        const addonQtyMinus=$("<button/>",{
            class:"mui-btn mui-btn--small mui-btn--gray mui-btn--fab",
            html:`<i class="fa fa-minus" aria-hidden="true"></i>`,
            disabled: !available
        }).on('click',()=>{
            if(!available){return}
            addonQtyInput[0].stepDown();
            addonQtyInput.trigger('change')
        })
        const addonQtyPlus=$("<button/>",{
            class:"mui-btn mui-btn--small mui-btn--primary mui-btn--fab",
            html:`<i class="fa fa-plus" aria-hidden="true"></i>`,
            disabled: !available
        }).on('click',()=>{
            if(!available){return}
            addonQtyInput[0].stepUp();
            addonQtyInput.trigger('change')
        })

        const addonActionsContainer=$("<div/>",{
            class:"d-flex justify-content-end align-items-start mb-1",
            html:[addonQtyMinus,addonQtyInput,addonQtyPlus]
        })
        const addonActions=$("<td/>",{
            class:"vertical-align-top border-0 px-0 py-1 show-on-licenses",
            html:[addonActionsContainer]
        });

       
        const addonRow=$("<tr/>",{
            class: !available ? 'addon-disabled' : '',
            html:[addonName,addonPrice,addonActions],
        }).on('click',()=>{
            if(!this.hasLicenses && available){
                if($(`#manager_addon_checkbox_${addon.id}`).is(':checked')){
                    $(`#manager_addon_checkbox_${addon.id}`).prop({checked:false})
                }else{
                    $(`#manager_addon_checkbox_${addon.id}`).prop({checked:true})
                }
                this.onSelectionChanged()
            }
        });
        if(!available){
            addonRow.attr('data-toggle','tooltip')
            .attr('data-placement','top')
            .attr('title','This add-on is not available on your current plan.')
            .attr('data-original-title','This add-on is not available on your current plan.').tooltip();
        }

        this.addonsListHTML.append(addonRow);
        
    };

    getSelectedAddonIds(){
        const selectedIds=[];
        this.addonsListHTML.find(`input[name='purchase_addon_qty_input']`).each((i,input)=>{
            // console.log("checking addon",$(input).val())
            if(parseInt($(input).val()) > 0){
                selectedIds.push({id:parseInt($(input).attr('addon-id')),qty:parseInt($(input).val())});
            }
        })
        return selectedIds
    };

    getCheckboxSelectedAddons(){
        const selectedIds=[];
        this.addonsListHTML.find(`input[name='manager_addon_selected_checkbox']`).each((i,input)=>{
            // console.log("checking addon",$(input).val())
            if(parseInt($(input).val()) > 0 && $(input).is(':checked')){
                selectedIds.push({id:parseInt($(input).val()),qty:1});
            }
        })
        return selectedIds
    }

    onSelectionChanged(){
        const selectedIdQTY=!this.hasLicenses ? this.getCheckboxSelectedAddons() : this.getSelectedAddonIds();
        console.log("selected addons",selectedIdQTY);
        const selectedIds=selectedIdQTY.map(a=>a.id);
        const selectedAddons=this.available.filter(addon=>selectedIds.includes(addon.id));
        for (let index = 0; index < selectedAddons.length; index++) {
            const addon = selectedAddons[index];
            addon.qty=selectedIdQTY.find(a=>a.id==addon.id).qty;

        }
        // console.log("Selected addons summary",selectedAddons)
        this.printSummary(selectedAddons);
        // console.log(`Comparing (${selectedIds.sort().toString()}) with (${this.initialSelectedIds.sort().toString()})`)
        this.setError('');
        if(this.haveAddonsChanged(selectedIdQTY)){
            this.enableSubmitButton();
        }else{
            this.disableSubmitButton();
        }

    }

    haveAddonsChanged(selectedAddons){
        const initialIds=this.myAddons.map(a=>a.id);
        const nowIds=selectedAddons.map(a=>a.id);
        if(initialIds.sort().toString() != nowIds.sort().toString()){
            return true;
        }

        for (let index = 0; index < selectedAddons.length; index++) {
            const addon = selectedAddons[index];
            const myAddon = this.myAddons.find(a=>a.id==addon.id);
            if(!myAddon){return true}
            if(addon.qty != myAddon.qty){
                return true
            }
        }
        return false;
    };
    printSummary(selectedAddons){
        
        if(selectedAddons.length){
            let summaryTotal=0;
            this.addonSummaryItems.html('');
            selectedAddons.forEach(addon=>{
                const interval=this.interval=="month" ? "Monthly" : "Annual";
                const rate=this.interval == "month" ? addon.month_price : addon.year_price;
                const addonPrice=rate * addon.qty;
                summaryTotal+=addonPrice;
               this.addonSummaryItems.append(`<tr>
                    <td class="vertical-align-top">
                        <div class="d-flex flex-column mb-1">
                            <span class="invoice-item-name text-invoice-amount">${addon.name} - ${interval}</span>
                        </div>
                    </td>
                    <td class="vertical-align-top">
                        <div class="d-flex flex-column mb-1">
                            <span class="invoice-item-name text-invoice-amount">${addon.qty}</span>
                        </div>
                    </td>
                    <td class="vertical-align-top">
                        <div class="d-flex flex-column mb-1">
                            <span class="invoice-item-name text-invoice-amount">$${rate/100}</span>
                        </div>
                    </td>
                    <td class="vertical-align-top">
                        <div class="d-flex justify-content-end align-items-start mb-1">
                            <span class="invoice-line-amount text-invoice-amount">$${addonPrice/100}</span>
                        </div>
                    </td>
                </tr>`);
            });

            this.addonSummaryTotal.html(`$${summaryTotal/100}`)
        }else{
            this.addonSummaryTotal.html(`$0.00`)
            this.addonSummaryItems.html(`<tr>
                <td class="vertical-align-top" colspan=4 >
                    <div class="d-flex justify-content-center mb-1 w-100">
                        <span class="invoice-item-name text-invoice-amount">No selected add-ons</span>
                    </div>
                </td>
            </tr>`);
        }
    };


    disableSubmitButton(){
        this.updateAddonsButton.prop({disabled:true})
    }

    enableSubmitButton(){
        this.updateAddonsButton.prop({disabled:false})
    }

    renderWorkspacesButton(){
        const button=`<button id="profile-workspace-suite-button" class="mui-btn mui-btn--raised mui-btn--primary width-200px mx-0" onclick="openWorkspaceSuite()">
            <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="17" height="17" x="0" y="0" viewBox="0 0 512 512" xml:space="preserve" class=""><g><g><path d="m497 120.5h-135.625v-29.808c0-33.397-27.171-60.567-60.567-60.567h-89.615c-33.396 0-60.567 27.17-60.567 60.567v29.808h-135.626c-8.284 0-15 6.716-15 15v272.5c0 40.735 33.141 73.875 73.875 73.875h364.25c40.734 0 73.875-33.14 73.875-73.875v-272.5c0-8.284-6.716-15-15-15zm-206.965 195.75c0 18.767-15.269 34.035-34.035 34.035s-34.035-15.268-34.035-34.035v-34.035h68.07zm15-64.035h-98.07c-8.284 0-15 6.716-15 15v27.247c-87.228-18.932-152.617-75.51-161.03-143.962h450.129c-8.413 68.452-73.801 125.03-161.029 143.963v-27.247c0-8.285-6.716-15.001-15-15.001zm-124.41-161.523c0-16.855 13.713-30.567 30.567-30.567h89.615c16.854 0 30.567 13.712 30.567 30.567v29.808h-150.75v-29.808zm301.375 317.308c0 24.193-19.683 43.875-43.875 43.875h-364.25c-24.192 0-43.875-19.682-43.875-43.875v-180.146c12.11 17.317 27.724 33.308 46.587 47.455 32.687 24.515 72.592 41.535 116.022 49.932 4.386 31.065 31.134 55.043 63.391 55.043s59.005-23.978 63.391-55.043c43.43-8.397 83.334-25.417 116.022-49.932 18.863-14.147 34.477-30.139 46.587-47.455z"></path></g></g></svg>
        &nbsp; EXECUTIVE SUITE</button>`;
        console.log('workspacebutton',$('#profile-workspace-suite-button').length)
        if($('#profile-workspace-suite-button').length==0){
            console.log('rendering button',button)
            $('#profile-team-members-button').after(button);
        }
    }

    updateAddons(){
        //validate
        this.disableSubmitButton();
        const agreementChecked=this.agreeTermsCheckbox.is(':checked');
        if(!agreementChecked){
            $("#addon_privacy_policy_error").html('Please agree to our Terms & Conditions and Privacy Policy.');
            this.enableSubmitButton()
            return;
        }
        $("#addon_privacy_policy_error").html('');
        const selectedAddons=!this.hasLicenses ? this.getCheckboxSelectedAddons() : this.getSelectedAddonIds();

        axios.put('/profile/billing/addons',{addons:selectedAddons}).then(response=>{
            console.log("Updated addons",response.data);
            if(!response.data.error){
                this.profilePage.getPlan();
                this.profilePage.getUpcomingInvoice();
                if(response.data.workspace){
                    this.renderWorkspacesButton();
                }
                this.closeModal(true);
            }else{
                this.setError(response.data.message);
                this.enableSubmitButton();
            }   
        }).catch(err=>{
            console.error(err);
            this.setError("Something went wrong.");
        })

    }

    setError(error=''){
        this.errorMessage.html(error);
    }
    closeModal(success=false){
        this.managerModal.modal('hide');
        this.setAddonsLoading();
        this.setError('');
        $("#addon_privacy_policy_error").html('');
        this.agreeTermsCheckbox.prop({checked:false});
        this.disableSubmitButton();
        this.updateAddonsButton.off();
        this.agreeTermsCheckbox.off('change');
        this.onClose(success);

    }
};